import { CommonModule } from '@angular/common';
import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';

@Component({
  selector: 'app-timezone-selector',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './timezone-selector.html',
  styleUrl: './timezone-selector.css'
})
export class TimezoneSelector {
  @Input() options: readonly string[] = [];
  @Input() value: string | null = null;
  @Input() placeholder: string = '';
  @Output() valueChange = new EventEmitter<string>();

  protected open = false;

  protected toggleOpen(): void {
    this.open = !this.open;
  }

  protected selectOption(option: string): void {
    this.valueChange.emit(option);
    this.open = false;
  }

  @HostListener('document:click')
  protected onDocumentClick(): void {
    this.open = false;
  }
}
